import { ContextMenu } from "lib/@components/context-menu-bar"

export const ScopedGroupContextMenu = ContextMenu("scopedSchedule")
